(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-frontrowmd"] && !Shopify.designMode) return;
  try {
    (() => {
    const loaderSelector = 'script[src*="/api/widgets/script?id=15516"]';
    if (!document.querySelector(loaderSelector)) {
      const loader = document.createElement('script');
      loader.async = true;
      loader.src = 'https://app.thefrontrowhealth.com/api/widgets/script?id=15516';
      loader.addEventListener('error', () => {
        console.error('FrontrowMD modal loader failed to load.');
      });
      document.head.appendChild(loader);
    }

    if (document.documentElement.dataset.frontrowMdModalTriggerReady) return;
    document.documentElement.dataset.frontrowMdModalTriggerReady = 'true';

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest('[data-frontrowmd-modal-trigger]')
        : null;
      if (!trigger) return;

      event.preventDefault();

      const modalSelector = 'iframe.iframe-modal-frontrow-3783';
      const openModal = () => window.postMessage('OPEN_MODAL_BRAND', window.location.origin);
      if (document.querySelector(modalSelector)) {
        openModal();
        return;
      }

      const observer = new MutationObserver(() => {
        if (!document.querySelector(modalSelector)) return;
        observer.disconnect();
        window.clearTimeout(timeoutId);
        openModal();
      });
      const timeoutId = window.setTimeout(() => {
        observer.disconnect();
        console.error('FrontrowMD modal did not become available after clicking its badge.');
      }, 15000);

      observer.observe(document.documentElement, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
